export default __webpack_public_path__ + "static/media/modul-image-3.baa54007.png";